export default "__VITE_ASSET__DV$Llkzi__"